jQuery( '.staggered-section .video-container .button.play' ).on( 'click', function() {
  jQuery( '.staggered-section .video-container video' )[0].play();

  jQuery( '.staggered-section .video-container video' ).prop( 'controls', true );

  jQuery( this ).hide();
} );


jQuery( document ).ready( function() {
  jQuery( '#staggeredSectionScrollToBigSlider' ).on( 'click', function() {
    $( 'html, body' ).animate( {
      scrollTop: $( "#bigSliderContainer" ).offset().top - 150
    }, 200 );
  } );
} );

if ( jQuery( '.staggered-section #iconsSlider' ).length ) {
  jQuery( '.staggered-section #iconsSlider' ).slick( {
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    infinite: true,
    arrows: false,
    dots: false,
    responsive: [
      {
        breakpoint: 400,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        }
      }
    ]
  } );
}